import React from "react"

export const ProvidersSettingsContext = React.createContext({
  ref: "",
  updateByUser: () => {},
})
